import Section from './Section';
import CompanionMaterialItem from './CompanionMaterialItem';
import DisplayItem from './DisplayItem';
import ChoiceInteraction from './ChoiceInteraction';
import { ItemInterface } from '@/controllers/session/models/IQtiSession';
import Utility from '@/util/Utility';
import DeliveryOptionsProvider from './DeliveryOptionsProvider';
import Test from './Test';
import ItemStatus from '@/status/ItemStatus';
import ItemStatusCalculator from '@/status/ItemStatusCalculator';

class Item extends DeliveryOptionsProvider implements DisplayItem {
  public static readonly ITEM_FLAGGED_BIT_POSITION: number = 0;

  private readonly _identifier: string;
  private readonly _name: string;
  private readonly _qti: string;
  private _section!: Section;
  private _state = '';
  private _currentItem = false;
  private _isFlagged = false;
  private readonly _companionMaterialItems: Array<CompanionMaterialItem> = new Array<CompanionMaterialItem>();
  private readonly choiceInteractions: Array<ChoiceInteraction> = new Array<ChoiceInteraction>();
  private _itemStatus: ItemStatus = ItemStatus.UNATTEMPTED;

  constructor(identifier: string, name: string, qti: string) {
    super();
    this._identifier = identifier;
    this._name = name;
    this._qti = qti;
  }

  get section(): Section {
    return this._section;
  }

  set section(value: Section) {
    this._section = value;
  }

  get state(): string {
    return this._state;
  }

  set state(value: string) {
    this._state = value;
    this._itemStatus = ItemStatusCalculator.determineItemStatus(this);
  }

  get currentItem(): boolean {
    return this._currentItem;
  }

  set currentItem(value: boolean) {
    //if (this.section.testPart.test.locationState === Test.SECTION_INSTRUCTIONS_STATE) {
    this.section.testPart.test.locationState = Test.NO_STATE;
    //}
    this._currentItem = value;
  }

  get identifier(): string {
    return this._identifier;
  }

  get name(): string {
    return this._name;
  }

  get qti(): string {
    return this._qti;
  }

  get itemStatus(): ItemStatus {
    return this._itemStatus;
  }

  set isFlagged(value: boolean) {
    this._isFlagged = value;
  }

  get isFlagged(): boolean {
    return this._isFlagged;
  }

  get companionMaterialItems(): Array<CompanionMaterialItem> {
    return this._companionMaterialItems;
  }

  addCompanionMaterialItem(companionMaterialItem: CompanionMaterialItem): void {
    this._companionMaterialItems.push(companionMaterialItem);
    companionMaterialItem.item = this;
  }

  addChoiceInteraction(choiceInteraction: ChoiceInteraction): void {
    this.choiceInteractions.push(choiceInteraction);
  }

  get itemIndex(): number {
    return this.section.items.indexOf(this);
  }
  //'Question ' +
  getItemTitle(): string {
    const i18n = (window as any).i18n.global;
    return this.itemIndex + 1 + '</b> ' + i18n.t('common.of') + ' ' + this.section.items.length;
  }

  getPercentage(): number {
    return ((this.itemIndex + 1) / this.section.items.length) * 100;
  }

  toItemInterface(): ItemInterface {
    let state = 0;
    if (this.isFlagged) {
      state = Utility.setBit(state, Item.ITEM_FLAGGED_BIT_POSITION);
    }
    return { identifier: this.identifier, state: state };
  }
}

export default Item;
